import { SHARED_ROUTES, STORAGE_KEYS } from '../constants';
import { AuthContextLoginParams } from '../models';
import { useSafePush } from './useSafePush';

const LoginViaParamsActionType = {
  LOGIN: 'login',
  CONTINUE_SIGNUP: 'continue-signup',
} as const;

export type LoginViaParamsActionType =
  (typeof LoginViaParamsActionType)[keyof typeof LoginViaParamsActionType];

export function useLoginViaParams(action: LoginViaParamsActionType = 'login') {
  const adminUrl = process.env['NEXT_PUBLIC_ADMIN_URL'];
  const { safePush } = useSafePush();
  return ({
    accessToken,
    refreshToken,
    role,
    rememberMe,
  }: AuthContextLoginParams) => {
    if (adminUrl) {
      const query = new URLSearchParams({
        [STORAGE_KEYS.ACCESS_TOKEN]: accessToken,
        [STORAGE_KEYS.REFRESH_TOKEN]: refreshToken,
        [STORAGE_KEYS.USER_ROLE]: role || '',
        [STORAGE_KEYS.REMEMBER_ME]: rememberMe ? 'true' : 'false',
        action: action,
      });
      safePush(
        `${adminUrl}${SHARED_ROUTES.login_via_params}?${query?.toString()}`
      );
      return;
    }
  };
}
